import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import trainTime from '../../lib/TrainTime';
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';
import FormControl from 'react-bootstrap/lib/FormControl';

import { translate as t } from '../../lib/I18n';
import FormError from '../form/Error';
import ValidatedField from '../form/ValidatedField';
import PureRenderComponent from '../PureRenderComponent';
import { SignupTypes } from '../../constants/AppConstants';

class CustomerDateOfBirth extends PureRenderComponent {

    static propTypes = Object.assign({
        label: PropTypes.string.isRequired,
        validation: PropTypes.object
    }, _.pick(ValidatedField.propTypes, [
        'form',
        'onChange',
        'disabled',
        'visited'
    ]));

    _handleChange = (fieldName, value) => {
        const { field } = this.props;
        const dob = this.props.form.get(field);
        this.props.onChange(field, dob.set(fieldName, value).set('isDirty', true));
    };

    render () {
        const { customValidationMessage, form, field, label, visited, outsideLabel } = this.props;
        const dob = form.get(field);
        const dateString = (dob.getDateOfBirth() && dob.getDateOfBirth().format('YYYY-MM-DD')) || '';
        const thisYear = trainTime().year();
        const validation = dob.getValidationSummary();
        const hideError = form.get('signup') === SignupTypes.WITHOUT_SMARTCARD && !dob.get('isDirty');

        return (
            <Col md={12} className="date-of-birth">
                <Row>
                    <FormControl type="hidden" name={field} value={dateString} />
                    <Col md={12}>
                        <p className="label">{label}</p>
                    </Col>
                    <Col xs={4} sm={4} md={4} lg={4} className="date-of-birth__select date-of-birth__select--first">
                        <ValidatedField type="select"
                            visited={visited}
                            form={dob}
                            validation={validation}
                            id="day"
                            name="day"
                            field="day"
                            data-test-id="date-of-birth-day-select"
                            onChange={this._handleChange}
                            hideOptional
                            hideError={hideError}
                            outsideLabel={outsideLabel}
                            label={<span className="sr-only">{t('customerdetails.dob.day')}</span>}
                            placeholder={t('customerdetails.dob.dd')}
                            labelClassName="sr-only"
                            groupClassName="select-container">
                            <option value="">{t('customerdetails.dob.dd')}</option>
                            {_.range(1, 32).map(dom => <option key={dom} value={dom}>{_.padStart(dom, 2, '0')}</option>)}
                        </ValidatedField>
                    </Col>
                    <Col xs={4} sm={4} md={4} lg={4} className="date-of-birth__select">
                        <ValidatedField type="select"
                            visited={visited}
                            form={dob}
                            validation={validation}
                            id="month"
                            name="month"
                            field="month"
                            data-test-id="date-of-birth-month-select"
                            onChange={this._handleChange}
                            hideOptional
                            hideError={hideError}
                            outsideLabel={outsideLabel}
                            label={<span className="sr-only">{t('customerdetails.dob.month')}</span>}
                            placeholder={t('customerdetails.dob.mm')}
                            labelClassName="sr-only"
                            groupClassName="select-container">
                            <option value="">{t('customerdetails.dob.mm')}</option>
                            {_.range(1, 13).map(mon => <option key={mon} value={mon}>{trainTime.months(mon - 1)}</option>)}
                        </ValidatedField>
                    </Col>
                    <Col xs={4} sm={4} md={4} lg={4} className="date-of-birth__select date-of-birth__select--last">
                        <ValidatedField type="select"
                            visited={visited}
                            form={dob}
                            validation={validation}
                            id="year"
                            name="year"
                            field="year"
                            data-test-id="date-of-birth-year-select"
                            onChange={this._handleChange}
                            hideOptional
                            hideError={hideError}
                            outsideLabel={outsideLabel}
                            label={<span className="sr-only">{t('customerdetails.dob.year')}</span>}
                            placeholder={t('customerdetails.dob.yyyy')}
                            labelClassName="sr-only"
                            groupClassName="select-container">
                            <option value="">{t('customerdetails.dob.yyyy')}</option>
                            {_.range(thisYear, thisYear - 99, -1).map(yr => <option key={yr} value={yr}>{yr}</option>)}
                        </ValidatedField>
                    </Col>
                    {customValidationMessage ?
                        <Col xs={ 12 } className="margin-top-negative">
                            <FormError data-test-id="date-of-birth-error" message={ customValidationMessage }/>
                        </Col>
                        :
                        <Col xs={ 12 }>
                            {validation.isInvalidDate && <FormError data-test-id="date-of-birth-invalid-date-error" message={validation.isInvalidDate}/>}
                            {validation.isTooYoung && <FormError data-test-id="date-of-birth-too-young-error" message={validation.isTooYoung}/>}
                            {validation.isInFuture && <FormError data-test-id="date-of-birth-in-future-error" message={validation.isInFuture}/>}
                        </Col>
                    }
                </Row>
            </Col>
        );
    }

}

export default CustomerDateOfBirth;
